<template>
  <div class="invoice-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <div class="payments-view" v-if="$hasPermission('can_view_payments')">
      <MsgblContent :type="message.direction" v-if="message.showEntityLink">
        <MsgblLinkHeader icon="invoice"
                        :title="message.appointment_title"
                        @click="navigateTo" />
      </MsgblContent>

      <MsgblContent :type="message.direction" v-if="message.showEntityCard">
        <MsgblLinkHeader icon="invoice"
                        :title="message.appointment_title"
                        @click="navigateTo" />

        <MsgblTextRow class="invoice-for" v-if="invoice.invoice_for">
          <MsgblTextLabel>{{$t('payment.info.for')}}:</MsgblTextLabel>
          <MsgblTextValue>{{invoice.invoice_for}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblTextRow class="invoice-amount" v-if="invoice.payment_status.amount_to_pay_h">
          <MsgblTextLabel>{{$t('payment.info.grand_total')}}:</MsgblTextLabel>
          <MsgblTextValue>{{invoice.payment_status.amount_to_pay_h}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblTextRow class="invoice-message" v-if="message.text">
          <MsgblTextLabel>{{$t('conversation.info.message')}}:</MsgblTextLabel>
          <MsgblTextValue><div v-html="message.text"></div></MsgblTextValue>
        </MsgblTextRow>

        <MsgblActions v-if="invoice.invoice_actions"
                      :actions="invoice.invoice_actions"
                      @action="actionClicked" />
      </MsgblContent>
    </div>

    <MsgblNoAccess v-else
                   icon="invoice"
                   :direction="message.direction">
    </MsgblNoAccess>
  </div>
</template>

<script>

import {
  BubbleHeader,
  MsgblContent,
  MsgblTextRow,
  MsgblActions,
  MsgblNoAccess,
  MsgblTextLabel,
  MsgblTextValue,
  MsgblLinkHeader,
} from './helpers'

export default {
  name: 'InvoiceBubble',
  components: {
    BubbleHeader,
    MsgblContent,
    MsgblLinkHeader,
    MsgblTextRow,
    MsgblTextLabel,
    MsgblTextValue,
    MsgblNoAccess,
    MsgblActions,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    invoice() {
      return this.message.messageable
    },
  },
  methods: {
    doAction(action, data) {
      this.$frontageApi.send('invoice-bubble-action', {action, data})
    },
    actionClicked({action}) {
      if (action === 'view')
        this.navigateTo()
      else if (action === 'view_payment')
        this.$frontageApi.navigateTo('app.payment.show', {uid: this.invoice.payment_uid})
      else if (action === 'view_payments')
        this.doAction(action, {payment_status: invoice.payment_status})
      else if (action === 'print')
        this.doAction(action, {url: `/invoices/${this.invoice.uid}/view?print=true`, invoice: this.invoice})
      else {
        this.doAction(action, {invoice: this.invoice})
      }
    },
    navigateTo() {
      this.$frontageApi.navigateTo('app.invoice.show', {uid: this.invoice.uid})
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_i18n-mixins';
.invoice-bubble {
  .invoice-icon {
    @include i-margin-mirror(0, 5px);
  }

  .no-permission {
    display: flex;
    align-items: center;
    padding: 10px;
  }
}
</style>
